import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-single-user-detail',
  templateUrl: './single-user-detail.component.html',
  styleUrls: ['./single-user-detail.component.css']
})
export class SingleUserDetailComponent implements OnInit {
  output1: any = [];
  weeKDays = [
    {
      week: 'Sunday',
      value: 1,
      checked:false
    },
    {
      week: 'Monday',
      value: 2,
      checked:false
    },
    {
      week: 'Tuesday',
      value: 3,
      checked:false
    },
    {
      week: 'Wednesday',
      value: 4,
      checked:false
    },
    {
      week: 'Thursday',
      value: 5,
      checked:false
    },
    {
      week: 'Friday',
      value: 6,
      checked:false
    },
    {
      week: 'Saturday',
      value: 7,
      checked:false
    },
  ];
  
  constructor(private employeeService:ServiceService,private route: ActivatedRoute, private router: Router) { }

  output:any=[]; //---store get() result--------
  UserId='';
  editUserId='';
  ChangePasswordShown=false
  SetPrivilegesShown=false
  alert=""
  isShown=false
  listOut:any=[]
  imgUrl=this.employeeService.ReturnBase();
  name=""
  role=""
  check_in=""
  check_out=""
  app_version=""
  space=" "
  imgError = false;
  
  // New properties for customer classification
  classificationLoading: boolean = false;
  userTypeDetails: any;
  dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  
  // Properties for department display
  selectedDepartmentNames: string[] = [];
  departmentsLoading: boolean = false;

  //************************************************************************* */
  //-----function for urouting to edit user details---------
  EditDetails(){
    console.log("Clicked")
    this.router.navigateByUrl(('admin/edit-user'));  
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
  
  DateFormat1(value:any){
    if(value==null){
      return;
    }
    value=value.substring(0, value.length - 1);
    return value
  }
  
  //--------function set user id---------
  getValue(){
    this.employeeService.setUserId(this.UserId)
  }
  
  ngOnInit(): void {
  this.route.queryParams.subscribe(params => {
    if(params['id']) {
      this.UserId = params['id'];
    } else {
      this.UserId = this.employeeService.getUserId();
    }

    console.log("employee id=", this.UserId)

    //-------api get()calling-------------
    this.employeeService.ViewEmployeeById('/'+this.UserId).subscribe((res)=>{
      this.output=res.data
      this.editUserId = this.UserId; // Use the same ID that's already in the URL
      console.log("this.output",this.output)
      this.name=this.output[0].employee_name
      this.role=this.output[0].role
      this.imgUrl=this.imgUrl+this.output[0].employee_document
      this.imgError = false;
      // After getting user details, fetch user type classification
      if (this.output[0] && this.output[0].user_type_id) {
        this.loadUserTypeDetails(this.output[0].user_type_id);
      }
    })

    //--------------------check in and check out----------------------------//
    this.employeeService.UserPrivilege(this.UserId).subscribe((res)=>{
      this.output1=res.data
      console.log("output",this.output1[0]);
      
      if(this.output1[0].hasOwnProperty('check_in')){
        this.check_in=this.output1[0].check_in
      }
      if(this.output1[0].hasOwnProperty('check_out')){
        this.check_out=this.output1[0].check_out
      }
      if(this.output1[0].hasOwnProperty('app_version')){
        this.app_version=this.output1[0].app_version
      }
      const schedule = this.output1[0].weekly_time_schedule;
      if (Array.isArray(schedule)) {
        this.weeKDays.forEach(day => {
          const sched = schedule.find((s: any) => s.day === day.value);
          day.checked = !!sched?.isActive;
        });
      }
    })
    //-----------------------------end---------------------------------------//

  }); // closes queryParams subscribe
}

  // Load user type details for classification
  loadUserTypeDetails(userTypeId: string) {
    this.classificationLoading = true;
    this.employeeService.userTypedetails(userTypeId).subscribe({
      next: (response) => {
        this.userTypeDetails = response.data[0];
        console.log('User Type Details:', this.userTypeDetails);
        
        // Load department names if available
        this.loadDepartmentNames();
        this.classificationLoading = false;
      },
      error: (err) => {
        console.error('Error loading user type details:', err);
        this.classificationLoading = false;
      }
    });
  }

  // Load department names
  loadDepartmentNames() {
    this.selectedDepartmentNames = [];
    if (!this.userTypeDetails) return;

    let departmentIds: any[] = [];
    
    if (this.userTypeDetails.warehouse_ids && Array.isArray(this.userTypeDetails.warehouse_ids)) {
      departmentIds = this.userTypeDetails.warehouse_ids;
    } else if (this.userTypeDetails.department_ids && Array.isArray(this.userTypeDetails.department_ids)) {
      departmentIds = this.userTypeDetails.department_ids;
    } else if (this.userTypeDetails.departments && Array.isArray(this.userTypeDetails.departments)) {
      departmentIds = this.userTypeDetails.departments;
    }
    
    if (departmentIds.length === 0) {
      this.selectedDepartmentNames = [];
      return;
    }

    const extractedIds = departmentIds.map((item: any) => {
      if (typeof item === 'string') {
        return item;
      } else if (item && item._id) {
        return item._id;
      } else if (item && item.id) {
        return item.id;
      }
      return item;
    }).filter(id => id);

    if (extractedIds.length === 0) {
      this.selectedDepartmentNames = [];
      return;
    }

    // Fetch all departments to map IDs to names
    this.departmentsLoading = true;
    this.employeeService.Warehouse_Dropdown().subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.selectedDepartmentNames = extractedIds.map((id: string) => {
            const dept = res.data.find((d: any) => d.warehouse_id === id || d.id === id);
            return dept ? this.getDepartmentDisplayName(dept) : `Unknown (ID: ${id})`;
          });
          console.log('✅ Department names loaded:', this.selectedDepartmentNames);
        }
        this.departmentsLoading = false;
      },
      error: (err) => {
        console.error('Error loading departments:', err);
        this.selectedDepartmentNames = extractedIds.map((id: string) => `ID: ${id}`);
        this.departmentsLoading = false;
      }
    });
  }

  // Get the display name for a department
  getDepartmentDisplayName(department: any): string {
    return department.warehouse_name || department.name || department.department_name || 'Unknown Department';
  }

  // Get formatted department names for display
  getFormattedDepartmentNames(): string {
    if (this.selectedDepartmentNames.length === 0) {
      return 'No departments selected';
    }
    return this.selectedDepartmentNames.join(', ');
  }

  // Get formatted classification data for display
  getFormattedClassificationData(): any[] {
    const formattedData: any[] = [];
    const tierLabels = ['Diamond', 'Platinum', 'Gold', 'Silver', 'Bronze'];
    
    if (this.userTypeDetails?.app_industry) {
      this.userTypeDetails.app_industry.forEach((industry: any) => {
        // Get existing tier data
        const existingTiers = industry.tier_levels || [];
        
        // Always create 5 rows for each industry
        tierLabels.forEach((tierName, tierIndex) => {
          // Find matching tier data or use defaults
          const tierData = existingTiers[tierIndex] || { from: 0, to: 0 };
          
          formattedData.push({
            industryName: industry.app_industry_name,
            tierName: tierName,
            from: tierData.from || 0,
            to: tierData.to || 0,
            isFirstRow: tierIndex === 0,
            rowSpan: tierLabels.length // Always 5
          });
        });
      });
    }
    
    return formattedData;
  }

  // Get tier badge class for styling
  getTierBadgeClass(label: string): string {
    const badgeClasses: { [key: string]: string } = {
      'Bronze': 'badge-bronze',
      'Silver': 'badge-silver',
      'Gold': 'badge-gold',
      'Platinum': 'badge-platinum',
      'Diamond': 'badge-diamond'
    };
    return badgeClasses[label] || 'badge-secondary';
  }

  // Get tier icon class
  getTierIconClass(label: string): string {
    const iconClasses: { [key: string]: string } = {
      'Bronze': 'fas fa-medal',
      'Silver': 'fas fa-medal',
      'Gold': 'fas fa-award',
      'Platinum': 'fas fa-shield-alt',
      'Diamond': 'fas fa-gem'
    };
    return iconClasses[label] || 'fas fa-star';
  }

  // NEW
  // Get total tiers count for summary
  getTotalTiersCount(): number {
    if (!this.userTypeDetails?.app_industry) return 0;
    return this.userTypeDetails.app_industry.length * 5;
  }

  // Normalize day name (handles API typo "wenday" -> "Wednesday")
  formatDayName(day: string): string {
    const dayMap: { [key: string]: string } = {
      'monday': 'Monday',
      'tuesday': 'Tuesday',
      'wenday': 'Wednesday',
      'wednesday': 'Wednesday',
      'thursday': 'Thursday',
      'friday': 'Friday',
      'saturday': 'Saturday',
      'sunday': 'Sunday'
    };
    return dayMap[day?.toLowerCase()] || day;
  }

getFilteredWeeklySchedule(): any[] {
    const schedule = this.output1?.[0]?.weekly_time_schedule;
    if (!Array.isArray(schedule)) return [];
    return schedule
      .slice()
      .sort((a: any, b: any) => a.day - b.day)
      .map((sched: any) => sched.isActive
        ? sched
        : { ...sched, workin_time: '', workout_time: '', lunch_in_time: '', lunch_out_time: '' }
      );
  }

  formatDayNumber(day: number): string {    const dayNumberMap: { [key: number]: string } = {
      1: 'Sunday',
      2: 'Monday',
      3: 'Tuesday',
      4: 'Wednesday',
      5: 'Thursday',
      6: 'Friday',
      7: 'Saturday'
    };
    return dayNumberMap[day] || String(day);
  }
}